<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="abnormalRecords">
			<template #ops>
				<el-button v-click-blur style="width: 100px" type="primary" @click="handleExport">导出记录</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-abnormal-records-${tenantType}`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiExceptionList)
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiExceptionList)
						}
					"
				></gc-table>
			</div>

			<gc-alarm-handle-dialog :show.sync="showHandleDialog" :detail="detail"></gc-alarm-handle-dialog>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import common from '../mixins/common'
import { apiExceptionList } from '@/apis/alarm.api'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { apiGetDeviceTypeList } from '@/apis/account.api'
import { deviceDetailPermissions } from '@/config/const'
import { isBlank, isObject } from '@/utils/validate'

export default {
	name: 'abnormalRecords',
	mixins: [common],
	data() {
		return {
			form: {
				deviceNo: null,
				designNo: null,
				deviceTypeClassify: null,
				deviceTypeIdList: null,
				exceptionType: null,
				exceptionReason: null,
				userType: null,
			},
			searchOptions: {},
			showHandleDialog: false,
			detail: {},
			cancelRequest: true,
			columns: [],
		}
	},
	computed: {
		exceptionType() {
			return this.$store.getters.dataList.exceptionType || []
		},
		exceptionReason() {
			return this.$store.getters.dataList.exceptionReason || []
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		searchCondition() {
			return [
				{
					key: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					needAllForSearch: true,
					searchOptionKey: {
						label: 'name',
						value: 'defaultValue',
					},
					hidden: this.tenantType === '1',
				},
				{
					key: 'deviceTypeIdList',
					dicKey: 'deviceTypeId',
					label: '设备类型',
					type: 'select',
					filterable: true,
					needAllForSearch: true,
					multiple: true,
					hidden: this.tenantType === '1',
				},
				{
					key: 'userType',
					dicKey: 'userType',
					label: '客户类型',
					type: 'select',
					needAllForSearch: true,
					searchOptionKey: {
						label: 'name',
						value: 'defaultValue',
					},
					hidden: this.tenantType === '0',
				},
				{
					key: 'exceptionType',
					label: '异常类型',
					type: 'select',
					needAllForSearch: true,
					searchOptionKey: {
						label: 'name',
						value: 'defaultValue',
					},
				},
				{
					key: 'exceptionReason',
					label: '异常原因',
					type: 'select',
					needAllForSearch: true,
					searchOptionKey: {
						label: 'name',
						value: 'defaultValue',
					},
				},
			].filter(item => !item.hidden)
		},
		filterFields() {
			const keywordFields = [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
				},
				{
					prop: 'designNo',
					label: '外观编号',
					type: 'input',
				},
			]
			const conditionFields = this.searchCondition.map(item => {
				return {
					prop: item.key,
					label: item.label,
					type: item.type || 'input',
					defaultValue: item.defaultValue,
					props: {
						searchOption: this.searchOptions[item.dicKey || item.key],
						filterable: item.filterable || false,
						needAllForSearch: item.needAllForSearch,
						searchOptionKey: item.searchOptionKey,
						multiple: item.multiple,
					},
				}
			})
			return [...keywordFields, ...conditionFields]
		},
		getDeviceTypeFlag() {
			return this.tenantType == 1
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
	},

	watch: {
		'form.deviceTypeClassify': {
			handler(newVal) {
				if (newVal) {
					this.form.deviceTypeIdList = []
				}
				this.queryDeviceTypeList()
			},
			immediate: true,
		},

		tenantType: {
			handler() {
				this.columns = [
					{
						key: 'deviceNo',
						name: '设备通讯编号',
						fixed: 'left',
						tooltip: true,
						dragDisable: true,
						disabledSelect: true,
					},
					{
						key: 'designNo',
						name: '外观编号',
						tooltip: true,
					},
					{
						key: 'userTypeName',
						name: '客户类型',
						hidden: this.tenantType === '0',
					},
					{
						key: 'firstCategoryName',
						name: '设备大类',
						tooltip: true,
						hidden: this.tenantType === '1',
					},
					{
						key: 'deviceTypeName',
						name: '设备类型名称',
						tooltip: true,
					},
					{
						key: 'userNo',
						name: '用户号',
					},
					{
						key: 'username',
						name: '客户/站点名称',
						tooltip: true,
					},
					{
						key: 'userPhone',
						name: '手机号码',
					},
					{
						key: 'userPhone2',
						name: '联系电话',
					},
					{
						key: 'addressName',
						name: '安装地址',
						tooltip: true,
					},
					{
						key: 'exceptionType',
						name: '异常类型',
					},
					{
						key: 'exceptionReason',
						name: '异常原因',
					},
					{
						key: 'offLineDuration',
						name: '离线时长',
					},
					{
						key: 'offLineThreshold',
						name: '离线周期',
					},
					{
						key: 'oprate',
						name: '操作',
						width: 250,
						render: (h, row) => {
							const childList = [
								this.$has('monitor:run:exception:update')
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => {
														this.handleLog(row)
													},
												},
											},
											'处理登记',
									  )
									: '',
								this.$has(deviceDetailPermissions)
									? h(
											'el-button',
											{
												props: {
													type: 'text',
													size: 'medium',
												},
												on: {
													click: () => {
														this.$router.push({
															name: 'deviceDetail',
															query: {
																deviceId: row.deviceId,
															},
															params: {
																name: 'BasicInfo',
															},
														})
													},
												},
											},
											'查看详情',
									  )
									: '',
							]
							const hasVNode = childList.some(item => isObject(item))
							return h('div', {}, hasVNode ? childList : '/')
						},
						fixed: 'right',
					},
				].filter(item => !item.hidden)
			},
			immediate: true,
		},
	},

	mounted() {
		const params = this.$route.params
		if (Object.keys(params).length) {
			const { deviceTypeClassify, exceptionType } = params
			this.form.deviceTypeClassify = deviceTypeClassify
			this.form.exceptionType = exceptionType
		}
		this.$set(this.searchOptions, 'deviceTypeClassify', this.$store.getters.dataList.deviceTypeClassify)
		this.$set(this.searchOptions, 'exceptionType', this.exceptionType)
		this.$set(this.searchOptions, 'exceptionReason', this.exceptionReason)
		this.$set(this.searchOptions, 'userType', this.$store.getters.dataList.userType || [])
		this.getList(1, apiExceptionList)
	},

	methods: {
		apiExceptionList,
		handleFilterSearch() {
			this.getList(1, apiExceptionList)
		},
		handleFilterReset() {
			this.getList(1, apiExceptionList)
		},

		...mapActions({
			getFirstCategory: 'common/getFirstCategory',
			getDeviceTypes: 'common/getAllDeviceTypeList',
		}),

		async queryDeviceTypeList() {
			apiGetDeviceTypeList({ tenantId: this.tenantId, deviceTypeClassify: this.form.deviceTypeClassify }).then(
				res => {
					let list = res.records || []
					let val = list.map(item => {
						return {
							value: item.deviceTypeId,
							label: item.deviceTypeName,
						}
					})
					this.searchOptions.deviceTypeId = val
				},
			)
		},

		handleLog(row) {
			this.detail = row
			this.showHandleDialog = true
		},

		handleExport() {
			if (!this.tableData.length) return this.$message.warning('暂无表格数据')
			this.$toast('下载中，请稍后...')
			const params = {}
			for (let key in this.form) {
				if (!isBlank(this.form[key])) {
					params[key] = this.form[key]
				}
			}
			const data = {
				method: 'post',
				url: '/monitor/run/exception/export/excel',
				fileName: '异常记录.xlsx',
				data: params,
			}
			exportReport(data, 'excel', '', this.$toast)
		},
	},

	activated() {
		if (this.$route.params?.update) {
			this.form = this.$options.data().form
			this.form.deviceTypeClassify = this.$route.params.deviceTypeClassify
			this.form.exceptionType = this.$route.params.exceptionType
			this.getList(1, apiExceptionList)
		}
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.serach-ops {
	margin-bottom: 8px;
}
</style>
